// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CyberlinksGraph-module__wrapper___NFr9B{position:relative}.CyberlinksGraph-module__loaderWrapper___ssRqa{position:absolute;top:45%;width:100%;text-align:center;z-index:1;font-size:22px}", "",{"version":3,"sources":["webpack://./src/features/cyberlinks/CyberlinksGraph/CyberlinksGraph.module.scss"],"names":[],"mappings":"AAAA,yCACE,iBAAA,CAGF,+CACE,iBAAA,CACA,OAAA,CACA,UAAA,CACA,iBAAA,CACA,SAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "CyberlinksGraph-module__wrapper___NFr9B",
	"loaderWrapper": "CyberlinksGraph-module__loaderWrapper___ssRqa"
};
export default ___CSS_LOADER_EXPORT___;
